/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {translate} from '@ion/core/src/locale/locale';
import {ErrorCode} from '@ion/core/src/types/entities';

/**
 * Retrieves the error message for a given error code.
 *
 * @param {number} errorCode - The error code to retrieve the message for.
 * @returns {string | null}  - The corresponding error message or null if the error code is undefined or null.
 */
export const getLoginErrorMessage = (errorCode: number | undefined | null): string | null => {
  const {Unauthorized, Forbidden, MethodNotAllowed} = ErrorCode;
  switch (errorCode) {
    case MethodNotAllowed:
    case Unauthorized:
    case Forbidden:
      return translate(`login:errorCodeMessages.${errorCode}`, {returnObjects: true});
    case undefined:
    case null:
      return null;
    default:
      return translate('notifications:error.client');
  }
};

/**
 * Determines if the provided error code is valid.
 *
 * @param {number} errorCode - The error code to validate.
 * @returns {boolean}        - True if the error code is valid, else false.
 */
export const isValidErrorCode = (errorCode: number): boolean => {
  return Object.values(ErrorCode).includes(errorCode);
};
